import SDAItem from './SDAItem'

export default class SDAInv {
    constructor(data = {}) {
        console.log(data)
        this.Hmerom = data.Hmerom || null
        this.NumberPar = data.NumberPar || null
        this.User_ID = data.User_ID || null
        this.qrURL = data.qrURL || ''
        this.invoiceMark = data.invoiceMark || ''
        this.HmeromExpire = data.HmeromExpire || null
        this.StandBy =  data.StandBy || 0
        this.SDAItems = (data.SDAItems || []).map(item => new SDAItem(item))
    }
} 